<form autocomplete="off" (ngSubmit)="register()">
  <div class="form__header">
    <div class="form__header-action">
      <a [routerLink]="[]" [queryParams]="authPage('register')"
        ><i class="zmdi zmdi-long-arrow-left"></i>{{ 'FORMS.back' | translate }}</a
      >
    </div>
    <div class="form__header-title">{{ 'FORMS.sign_up_title' | translate }}</div>
  </div>
  <div class="form__group">
    <app-ph-input
      [placeholder]="'FORMS.your_email' | translate"
      type="email"
      [validation]="'email'"
      name="email"
      [correctForm]="form"
    ></app-ph-input>
  </div>
  <div class="form__group-addon">
    <div class="form__group">
      <app-ph-input
        [placeholder]="'FORMS.your_password' | translate"
        [validation]="'password'"
        [errorDescription]="true"
        type="password"
        name="plain_password"
        [correctForm]="form"
      ></app-ph-input>
    </div>
    <div class="form__group">
      <app-ph-input
        [placeholder]="'FORMS.confirm_password' | translate"
        [validation]="'password'"
        [correctForm]="form"
        sameValue="plain_password"
        name="resetPassword"
        type="password"
      ></app-ph-input>
    </div>
  </div>
  <app-ph-input [validation]="'checkbox'" type="checkbox" name="confirm" [correctForm]="form">
    {{ 'AUTH.i_accept_the' | translate }}
    <a [routerLink]="['/' + RoutesPath.default.terms]" class="text--primary-light">{{
      'AUTH.terms_of_service' | translate
    }}</a>
  </app-ph-input>
  <div class="form__action">
    <button class="btn btn--primary btn--block btn--lg" [disabled]="btnDisabled">
      {{ 'AUTH.sign_up_and_create_company_account' | translate }}
    </button>
  </div>
</form>
